import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "fw-bolder bg-light" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", _hoisted_1, [
      (_ctx.mapping.updateOrder)
        ? (_openBlock(), _createElementBlock("th", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.mapping.ShowInnerRows)
        ? (_openBlock(), _createElementBlock("th", _hoisted_3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapping.Columns, (column, i) => {
        return (_openBlock(), _createElementBlock("th", {
          key: i,
          onClick: ($event: any) => (_ctx.maybeSort(column)),
          class: _normalizeClass(_ctx.headerClass(column))
        }, _toDisplayString(column.label), 11, _hoisted_4))
      }), 128)),
      (_ctx.hasActions)
        ? (_openBlock(), _createElementBlock("th", _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}